import gql from 'graphql-tag';
import { AVAILABILITY_FRAGMENT } from '@components/ProductPage/ProductThumbnail/queries';

export const RECOMMENDED_PRODUCT_FRAGMENT = gql`
  ${AVAILABILITY_FRAGMENT}
  fragment recommendedProduct on Product {
    id
    name
    isPublished
    brand
    brandLink {
      id
    }
    url
    urlForGraphql
    publicationDate
    price {
      amount
    }
    thumbnail(size: 255) {
      url
      alt
    }
    availability {
      ...availability
    }
    productReviewsAggregation {
      id
      rating
      reviewCount
    }
    productType {
      isMgs
    }
  }
`;

export const RECOMMENDED_PRODUCTS = gql`
  ${RECOMMENDED_PRODUCT_FRAGMENT}
  query recommendedProducts($id: ID!, $type: String!, $limit: Int, $isMgs: Boolean) {
    product(id: $id) {
      recommendedProducts(recommendationType: $type, limit: $limit, isMgs: $isMgs) {
        ...recommendedProduct
      }
    }
  }
`;
